export var LoanPurposes;
(function (LoanPurposes) {
    LoanPurposes["Empty"] = "loan_application_id";
    LoanPurposes["Studies"] = "for_studies";
    LoanPurposes["VehicleFinancing"] = "vehicle_financing";
    LoanPurposes["HomeImprovements"] = "home_improvements";
    LoanPurposes["MedicalExpenses"] = "medical_expenses";
    LoanPurposes["Consumption"] = "for_consumption";
    LoanPurposes["Vacation"] = "for_vacation";
    LoanPurposes["DebtConsolidation"] = "debt_consolidation";
})(LoanPurposes || (LoanPurposes = {}));
export var LoanStatuses;
(function (LoanStatuses) {
    LoanStatuses["Submitted"] = "submitted";
    LoanStatuses["Collecting"] = "collecting";
    LoanStatuses["Expired"] = "expired";
    LoanStatuses["Collected"] = "collected";
    LoanStatuses["Rejected"] = "rejected";
    LoanStatuses["Active"] = "active";
    LoanStatuses["Overdue"] = "overdue";
    LoanStatuses["Paid"] = "paid";
    LoanStatuses["Canceled"] = "canceled";
    LoanStatuses["Cancelled"] = "cancelled";
    LoanStatuses["ApplicationWaitingForPayout"] = "application_waiting_for_payout";
    LoanStatuses["WaitingClientConfirmation"] = "waiting_client_confirmation";
    LoanStatuses["Confirmed"] = "confirmed";
    LoanStatuses["Invested"] = "invested";
    LoanStatuses["Returned"] = "returned";
})(LoanStatuses || (LoanStatuses = {}));
export var DocumentTypes;
(function (DocumentTypes) {
    DocumentTypes["PreContractualAgreement"] = "pre-contractual-agreement";
    DocumentTypes["SpecialConditions"] = "special-conditions";
})(DocumentTypes || (DocumentTypes = {}));
export const ACTIVE_LOAN_APPLICATION_STATUSES = [
    LoanStatuses.Submitted,
    LoanStatuses.Collecting,
    LoanStatuses.Active,
    LoanStatuses.ApplicationWaitingForPayout,
    LoanStatuses.Collected,
    LoanStatuses.Overdue,
    LoanStatuses.WaitingClientConfirmation,
];
